module.exports = __webpack_public_path__ + "static/img/wechat_QR.2b697232.jpg";